import axios from 'axios';

/**
 * Service for API Key operations
 * These methods will eventually be moved to @kjdelectronics/ps-quotetool-domain
 */

const getBaseUrl = () => {
    return window.location.hostname === "localhost" ? "http://localhost:3001/v1" : "/v1";
};

export const createApiKey = async ({ userId }) => {
    const response = await axios.post(
        `${getBaseUrl()}/admin/api-keys`,
        { userId },
        { withCredentials: true }
    );

    return response.data;
};

export const revokeApiKey = async ({ guid, userId }) => {
    if (!guid) {
        throw new Error('API Key GUID is required');
    }

    if (!userId) {
        throw new Error('User ID is required');
    }

    const response = await axios.delete(
        `${getBaseUrl()}/admin/api-keys`,
        {
            withCredentials: true,
            data: { guid, userId }
        }
    );

    return response.data;
};
